import axios from "axios";
import ToastMessage from "../../../components/toast";

export async function getDailyScheduleReport(companyShortName, isTomorrow) {
    return axios.get(`api/scheduler/daily-schedule-report`, {
        params: { companyShortName, isTomorrow },
        responseType: "arraybuffer",
    }).catch(er => ToastMessage(er.message, "error"));
};

